/**
 * BrandLogo — single source of truth for the Physiogenic brand mark.
 *
 * The actual image lives at /logo.jpg in /app/frontend/public so it can be
 * referenced from anywhere (auth pages, sidebar, mobile header, landing).
 * Override at runtime by passing `src` (e.g. settings.clinic_logo_url).
 */
import React from 'react';

const DEFAULT_SRC = '/logo.jpg';

export function BrandLogo({ size = 36, src, alt, className = '', testid = 'brand-logo', showCopyright = false }) {
  const effective = src || DEFAULT_SRC;
  const isCustom = !!src;
  return (
    <span
      data-testid={testid}
      className={`inline-flex items-center justify-center overflow-hidden rounded-lg shadow-sm ring-1 ring-black/5 bg-white shrink-0 relative ${className}`}
      style={{ width: size, height: size, minWidth: size, minHeight: size }}
    >
      <img
        src={effective}
        alt={alt || (isCustom ? 'Clinic logo' : 'Physiogenic')}
        width={size}
        height={size}
        className="w-full h-full object-cover select-none"
        draggable={false}
      />
    </span>
  );
}

export default BrandLogo;
